import { CreatePharmacy, PaperSize, Pharmacy, PharmacyPage, PrinterType, Role, User } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithEdit } from "./mixins/WithEdit";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

type PrinterSettings = {
  printerType: PrinterType;
  ipAddress?: string;
  paperSize: PaperSize;
};

export class Endpoint extends BaseEndpoint("pharmacies") {
  getRoles(id: string): Promise<Role[]> {
    return this.request(`${id}/roles`);
  }
  getUsers(id: string): Promise<User[]> {
    return this.request(`${id}/users`);
  }

  updatePrinterSettings(pharmacyId: string, printerSettings: PrinterSettings): Promise<void> {
    return this.request(`${pharmacyId}/printer-settings`, { method: "PUT", body: printerSettings });
  }
}

const withGetAll = WithSearchableGetPage<typeof Endpoint, Pharmacy, PharmacyPage>(Endpoint);

export const PharmacyEndpoint = WithEdit<typeof withGetAll, Pharmacy, CreatePharmacy>(withGetAll);
